<woa-modal-page-layout [title]="title()"
                       [translationParams]="{'text': promo().appText1, 'promoName': promo().name}">
    @if (imageSpec(); as imageSpec) {
        @if (imageSpec.image) {
            <div class="promo-image" woa-activatable (onActivate)="performAction(true)">
                @if (isFedeltaImageData(imageSpec.image)) {
                    <img class="promo-image-object" [ngClass]="{'auto-crop': imageSpec.autoCropImage}" [woa-image-cache]="imageSpec.image" alt="">
                } @else if (imageSpec.image !== undefined) {
                    <!--suppress AngularNgOptimizedImage -->
                    <img class="promo-image-object" [ngClass]="{'auto-crop': imageSpec.autoCropImage}" [src]="imageSpec.image | url" alt="">
                }
            </div>
        }
    }
    @if (menuModel.getMenuItemDisplayName(menuItem()) && promo().showDetailsOnPopup) {
        <div class="promo-product">
            <div class="promo-product-name">
                {{ menuModel.getMenuItemDisplayName(menuItem()) }}
            </div>
            @if (!informational()) {
                <div class="promo-product-price">
                    {{ menuItem().sellable.defaultPrice | woaCurrency }}
                </div>
            }
        </div>
    }
    @if (menuItem()?.sellable) {
        <woa-dietary-panel [sellable]="menuItem().sellable" class="promo-dietary"></woa-dietary-panel>
    }
    @if (promo().showMessageOnPopup && promo().appText2) {
        <div class="promo-message">
            {{ promo().appText2 }}
        </div>
    }
    @if (promo().showDescriptionOnPopup && menuModel.getMenuItemDescription(menuItem())) {
        <div class="promo-description"
             [innerHtml]="menuModel.getMenuItemDescription(menuItem()) | html"></div>
    }
    @if (promo().showActionButtonOnPopup && !hasAction()) {
        <woa-button woa-page-footer-control
                    [prominence]="ButtonProminence.LOW" [label]="'woa.button.common.ok'"
                    (onActivate)="dismiss()"></woa-button>
    }
    @if (promo().showActionButtonOnPopup && hasAction()) {
        <woa-button woa-page-footer-control
                    [prominence]="ButtonProminence.LOW" [label]="'woa.button.promo.decline'"
                    (onActivate)="dismiss()"></woa-button>
    }
    @if (promo().showActionButtonOnPopup && hasAction()) {
        <woa-button woa-page-footer-control
                    [label]="'woa.button.promo.' + promo().popupAction"
                    (onActivate)="performAction()"></woa-button>
    }
</woa-modal-page-layout>
